// Copyright 2026, University of Maryland, All Rights Reserved
import { type FC } from 'react'

import type { RendererComponentProps } from '@/app-shell/renderer-components'
import { SectionLayout } from '../components/SectionLayout'
import { extractSections, extractScore } from '../hooks/extractors'

export const SectionReportRenderer: FC<RendererComponentProps> = ({ slotData = {} }) => {
  const sectionsRes = slotData.sections ?? null
  return (
    <SectionLayout
      headline={undefined}
      summary={undefined}
      score={extractScore(sectionsRes)}
      sections={extractSections(sectionsRes)}
    />
  )
}
